// extracted by mini-css-extract-plugin
export var container = "carouselSection-module--container--9c282";
export var content = "carouselSection-module--content--44cd1";
export var heading = "carouselSection-module--heading--2ce68";
export var image = "carouselSection-module--image--1e088";
export var info = "carouselSection-module--info--d035e";
export var subContainer = "carouselSection-module--subContainer--a544c";
export var subtitle = "carouselSection-module--subtitle--7f9b0";